module.exports = __webpack_public_path__ + "912cbef04f025e730314cabb95f777f7.png";